import React, {  Component } from 'react';
import { connect } from 'react-redux';

class ConfirmReleaseYesNoOverlayDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showDialog: false
        }
    }
	componentDidMount() {
		// window.scrollTo(0, 0);
		this.setState({
            showDialog: this.props.showDialog
        });
	}
    closeDialog(event) {
        event.preventDefault();
        this.setState({
            showDialog: false
        });
		this.props.handleDialog('ConfirmReleaseYesNoOverlayDialog');
    }
	handleYes(event) {
		this.props.updateOrderStatus('Create', 'showConfirmReleaseYesNoOverlayDialog');
	}
    render() {
        return (
			<div className={"overlayDialog "+(this.state.showDialog?"visible":"hide")} id="confirmReleaseYesNoOverlayDialog">
                <div className="blackoutLayer"></div>
                <div className="overlayDialogWindow">
                    <a className="closeButton" onClick={this.closeDialog.bind(this)}>×</a>
                    <h2 className="title">Confirm Booking</h2>
                    <p><b>You are about to book this order.</b></p>
                    <p>Once booked, this order will be eligible for shipment. Some orders with delivery dates in the future or ones that contain a backordered product may still be available to edit in Customernet.</p>
                    <p>Do you want to continue?</p>
                    <div className="noButtonContainer">
                        <a className="noButton blueButton" onClick={this.closeDialog.bind(this)}>No</a>
                    </div>
                    <div className="yesButtonContainer">
                        <a className="yesButton blueButton" onClick={this.handleYes.bind(this)}>Yes</a>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
   return {state};
};

ConfirmReleaseYesNoOverlayDialog = connect(mapStateToProps)(ConfirmReleaseYesNoOverlayDialog);
export default ConfirmReleaseYesNoOverlayDialog;



// WEBPACK FOOTER //
// ./src/App/components/dialogs/confirmReleaseYesNoOverlayDialog.js